<div class="search-bar" [ngClass]="layoutService.isMobileLayout && 'mobile'">
  <input class="search-input" [ngClass]="layoutService.isMobileLayout && 'mobile'" [(ngModel)]="location" (keyup.enter)="getLocation()" placeholder="Zoek naar adres">
  <button class="button-primary-search ml-1" [ngClass]="layoutService.isMobileLayout && 'mobile'" (click)="getLocation()"><i class="fas fa-search"></i></button>
</div>
